import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LicenseProvider } from './context/LicenseContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import LicenseBanner from './components/LicenseBanner';
import LicenseGate from './components/LicenseGate';
import Home from './pages/Home';
import {
  ReportingProducePage,
  ReportingConsultPage,
  ReportingManualImportPage,
  SettingsPage,
  ArchivesPage,
} from './pages/ReportingPages';
import LicensePage from './pages/LicensePage';
import Watermark from './components/Watermark';
import CIDPage from './pages/CIDPage';
import AuditLogPage from './pages/AuditLogPage';
import { ConnectorList } from './modules/connectors';

function App() {
  return (
    <AuthProvider>
      <LicenseProvider>
        <Router>
          <div className="min-h-screen bg-slate-50 flex flex-col">
            <Navbar />
            <LicenseBanner />
            <main className="flex-1">
              <Routes>
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Home />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/reporting/produce"
                  element={
                    <ProtectedRoute roles={['reporting_produce', 'admin_apps', 'admin']}>
                      <LicenseGate module="reporting">
                        <ReportingProducePage />
                      </LicenseGate>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/reporting/consult"
                  element={
                    <ProtectedRoute roles={['reporting_access', 'admin_apps', 'admin']}>
                      <LicenseGate module="reporting">
                        <ReportingConsultPage />
                      </LicenseGate>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/settings"
                  element={
                    <ProtectedRoute roles={['reporting_settings', 'admin_apps', 'admin']}>
                      <SettingsPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/archives"
                  element={
                    <ProtectedRoute roles={['reporting_access', 'admin_apps', 'admin']}>
                      <LicenseGate module="reporting">
                        <ArchivesPage />
                      </LicenseGate>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/connectors"
                  element={
                    <ProtectedRoute roles={['support', 'admin_apps', 'admin']}>
                      <ConnectorList />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/license"
                  element={
                    <ProtectedRoute roles={['admin_apps', 'admin']}>
                      <LicensePage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/reporting/cid/:closingDate/:fichier"
                  element={
                    <ProtectedRoute roles={['reporting_cid', 'admin_apps', 'admin']}>
                      <LicenseGate module="reporting">
                        <CIDPage />
                      </LicenseGate>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/reporting/audit"
                  element={
                    <ProtectedRoute roles={['reporting_access', 'admin_apps', 'admin']}>
                      <LicenseGate module="reporting">
                        <AuditLogPage />
                      </LicenseGate>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/reporting/import-manuel"
                  element={
                    <ProtectedRoute roles={['reporting_produce', 'admin_apps', 'admin']}>
                      <LicenseGate module="reporting">
                        <ReportingManualImportPage />
                      </LicenseGate>
                    </ProtectedRoute>
                  }
                />

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Watermark />
          </div>
        </Router>
      </LicenseProvider>
    </AuthProvider>
  );
}

export default App;
